import React from 'react';
import { Alert, Button, TextField, Typography } from '@mui/material';
import { PlayerCardLayout } from '../../components/PlayerCardLayout';

export function UnlockPage({ header, assignedLabel, completionMessage, secretWord, setSecretWord, onUnlock, error }) {
  return (
    <PlayerCardLayout header={header}>
      <Alert severity="success">{assignedLabel}</Alert>
      <Typography variant="h4">Čestitamo!</Typography>
      <Typography>{completionMessage}</Typography>
      <Typography>Da biste otključali idući krug, unesite tajnu riječ.</Typography>
      <TextField fullWidth label="Tajna riječ" value={secretWord} onChange={(event) => setSecretWord(event.target.value)} />
      {error && <Alert severity="error">{error}</Alert>}
      <Button variant="contained" onClick={onUnlock}>Otključaj idući krug</Button>
    </PlayerCardLayout>
  );
}
